'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleResponseHeader = undefined;

var handleResponseHeader = exports.handleResponseHeader = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response, onMaintenance) {
    var responseBody;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _handleErrors.handleFetchResponse)(response, onMaintenance);

          case 2:
            responseBody = _context.sent;
            return _context.abrupt('return', {
              headers: response.headers,
              body: responseBody
            });

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function handleResponseHeader(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _handleErrors = require('./handle-errors');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/rest/handle-response-header.js
// module id = 2092
// module chunks = 0